import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IErrorResponse } from 'common/models/api-service/error-response.model';
import { ApiStatus } from 'common/enums';
import { FileDetails } from 'common/models';

import initialFileUploadState from './fileUpload.state';
import { SyncDetails, UploadFileDetails } from 'common/models/data/fileUpload.model';

const fileUploadSlice = createSlice({
    name: 'fileUpload',
    initialState: initialFileUploadState,
    reducers: {
        uploadFile: (
            state,
            {
                payload
            }: PayloadAction<{
                files: Array<FileDetails>;
                variantName: string | null;
                targetId: string;
                entityType: string;
            }>
        ) => {
            state.uploadingFiles = payload.files;
            state.selectedFiles = [];
            state.uploadResponse.status = ApiStatus.LOADING;
        },
        uploadFileSuccess: (state, { payload }: PayloadAction<string>) => {
            state.uploadResponse.status = ApiStatus.SUCCESS;
            state.uploadResponse.message = payload;
            state.isVisible = false;
            state.uploadingFiles = [];
            state.selectedFiles = [];
        },
        uploadFileFailed: (state, { payload }: PayloadAction<IErrorResponse>) => {
            state.uploadResponse.status = ApiStatus.ERROR;
            state.uploadResponse.error = payload;
            state.selectedFiles = state.uploadingFiles;
            state.uploadingFiles = [];
        },
        setVisibility: (state, { payload }: PayloadAction<boolean>) => {
            state.isVisible = payload;
        },
        setSelectedFiles: (state, { payload }: PayloadAction<Array<FileDetails>>) => {
            state.selectedFiles = payload;
        },
        setUploadingFiles: (state, { payload }: PayloadAction<Array<FileDetails>>) => {
            state.uploadingFiles = payload;
        },
        resetUploadResponse: (state) => {
            state.uploadResponse = {};
        },
        getSyncDetails: (state) => {
            state.syncDetails.status = ApiStatus.LOADING;
            state.syncDetails = {};
        },
        getSyncDetailsSuccess: (state, { payload }: PayloadAction<UploadFileDetails>) => {
            state.syncDetails.status = ApiStatus.SUCCESS;
            state.syncDetails.data = payload;
        },
        getSyncDetailsFailed: (state) => {
            state.syncDetails.status = ApiStatus.ERROR;
        },
        fetchUploadStatus: (state) => {
            state.uploadFileDetails.status = ApiStatus.LOADING;
        },
        fetchUploadStatusSuccess: (state, { payload }: PayloadAction<UploadFileDetails>) => {
            state.uploadFileDetails.status = ApiStatus.SUCCESS;
            state.uploadFileDetails.data = payload;
        },
        fetchUploadStatusFailed: (state) => {
            state.uploadFileDetails.status = ApiStatus.ERROR;
        }
    }
});

export default fileUploadSlice.reducer;
export const fileUploadActions = fileUploadSlice.actions;
